import { ENewQuestionModalStep } from '../../../types/newQuestion';
import { TReduxActions } from '../../../types/redux';
import { EStepActionTypes } from '../../../actions/newQuestion';

export const defaultValue = ENewQuestionModalStep.Question;

export function stepReducer(
  state: ENewQuestionModalStep = defaultValue,
  { type, payload }: TReduxActions,
): ENewQuestionModalStep {
  if (type === EStepActionTypes.Set) {
    return payload;
  }

  return state;
}
